









































import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component } from 'vue-property-decorator';

import Divider from '@/shared/components/Divider/Divider.vue';
import GrabInTheBottom from '@/shared/components/GrabInTheBottom/GrabInTheBottom.vue';
import LoginMobile from '@/app/features/Customer/features/Login/LoginMobile.vue';
import RegisterMobile from '@/app/features/Customer/features/Register/RegisterMobile.vue';
import OfferCard from './components/OfferCard/OfferCard.vue';
import ReCAPTCHABranding from '@/shared/components/ReCAPTCHABranding/ReCAPTCHABranding.vue';

import { EErrorScope } from '@/helpers/enums';
import { executeCaptcha } from '@/helpers/captcha';
import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';
import { sendInteractEvent } from '@/helpers/events';

const ErrorModule = namespace('App/Error');
const CustomerModule = namespace('App/Customer');
const CheckoutModule = namespace('App/Checkout');
const BehaviorModule = namespace('App/Behavior');

@Component({
  components: {
    OfferCard,
    Divider,
    GrabInTheBottom,
    LoginMobile,
    RegisterMobile,
    ReCAPTCHABranding,
  }
})
export default class OfferMobile extends Vue {
  @ErrorModule.Mutation('hideErrorsByScope')
  private hideErrorsByScope: Function;

  @CheckoutModule.Getter('isRenewal')
  private isRenewal: boolean;

  @CustomerModule.Getter('isLogged')
  private customerIsLogged: boolean;

  @CheckoutModule.Getter
  private customTemplateGuid: string;

  @BehaviorModule.Getter
  private isCaptchaValid: boolean;

  @BehaviorModule.Action
  private setCaptchaValid: Function;

  private clearErrors() {
    return this.hideErrorsByScope(EErrorScope.login);
  }

  private get isCheckoutCopy () {
    return !this.isRenewal && this.customTemplateGuid;
  }

  private get hideOffer() {
    return this.isCheckoutCopy && !this.customerIsLogged;
  }

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private goToRegister() {
    this.clearErrors;

    sendInteractEvent({
      action: EInteractEventTrackerAction.CHK_REGISTER,
      options: {
        avoidDuplicate: true,
      }
    });
  }

  mounted() {
    executeCaptcha('signin')
      .then((success: boolean) => {
        this.setCaptchaValid(success);
      });
  }
}
